import options from './screenshot.directive';

export default {
    selector: 'dtScreenshot',
    options
};
